import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { ExportType } from 'app/shared/utils/tableExportUtil';
import { LucideModule } from '../../modules/lucide.module';

interface OpcaoExportacao {
  type: ExportType;
  label: string;
  /** Texto do selo colorido. Fica vazio quando a opcao nao gera arquivo. */
  selo?: string;
  /** Icone do selo, usado apenas quando nao ha extensao para exibir. */
  icon?: string;
  cor: 'azul' | 'verde' | 'ciano' | 'ambar' | 'vermelho' | 'roxo' | 'neutro';
}

interface GrupoExportacao {
  titulo: string;
  opcoes: OpcaoExportacao[];
}

@Component({
  selector: 'app-export-dropdown',
  standalone: true,
  imports: [CommonModule, LucideModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './export-dropdown.component.html'
})
export class ExportDropdownComponent {
  @Input() label = 'Exportar Dados';
  @Output() exportType = new EventEmitter<ExportType>();

  /** Os formatos ficam agrupados pelo tipo de saida para encurtar a leitura da lista. */
  readonly grupos: GrupoExportacao[] = [
    {
      titulo: 'Planilha',
      opcoes: [
        { type: ExportType.Excel, label: 'Excel', selo: 'XLSX', cor: 'verde' },
        { type: ExportType.Csv, label: 'CSV', selo: 'CSV', cor: 'azul' },
        { type: ExportType.Ods, label: 'OpenDocument', selo: 'ODS', cor: 'ciano' }
      ]
    },
    {
      titulo: 'Documento',
      opcoes: [
        { type: ExportType.Pdf, label: 'PDF', selo: 'PDF', cor: 'vermelho' },
        { type: ExportType.Print, label: 'Imprimir', icon: 'printer', cor: 'neutro' }
      ]
    },
    {
      titulo: 'Formatos de integração',
      opcoes: [
        { type: ExportType.Json, label: 'JSON', selo: 'JSON', cor: 'roxo' },
        { type: ExportType.Xml, label: 'XML', selo: 'XML', cor: 'ambar' }
      ]
    }
  ];
}
